export default {
  lockEditAllMessage: '编辑模式下禁用其他功能',
}
